"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardWarningBanner = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var CardWarningBanner = /** @class */ (function (_super) {
    __extends(CardWarningBanner, _super);
    function CardWarningBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.togglePopup = function () {
            _this.props.interaction.uistate.paymentCardTypeIsCorrect = true;
            _this.setState({ showBanner: false });
        };
        _this.navigateToChangePaymentCard = function () {
            window.sessionStorage.setItem("renewalInteraction", _this.props.interaction._id);
            window.sessionStorage.setItem("redirectJourney", "renewal");
            window.sessionStorage.setItem("product", "annualMotor");
            window.location.assign("/dashboard/account/changeCard/" + _this.props.interaction.agreementNumber);
        };
        _this.state = {
            showBanner: true
        };
        return _this;
    }
    CardWarningBanner.prototype.render = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.togglePopup });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "falcon-modal", isOpen: this.state.showBanner },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.togglePopup, close: closeBtn },
                    React.createElement("div", { className: "d-flex gdpr-title-format" },
                        React.createElement("img", { src: "/img/attention_icon_blue.png", alt: "Attention", width: 40, height: 40 }),
                        React.createElement("span", { className: "ml-3 banner-text" }, "We can only accept monthly payment by debit card"))),
                React.createElement(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto" },
                    React.createElement("div", { className: "widget personalInfo-widget gdpr-popup-text-format" },
                        React.createElement("p", null, "You used a credit card when you paid in full for your policy last year."),
                        React.createElement("p", { className: "font-weight-bold" }, "Because you've changed to monthly payments for next year, we need you to use a debit card."))),
                React.createElement("div", { className: "justify-content-center flex-column pl-5 pr-5 pb-3" },
                    React.createElement("div", null,
                        React.createElement("button", { type: "button", className: "btn btn-primary btn-next w-100", onClick: this.navigateToChangePaymentCard }, "Change payment card")),
                    React.createElement("div", null,
                        React.createElement("button", { type: "button", className: "btn btn-white w-100 mb-0", onClick: this.togglePopup }, "Cancel changes"))))));
    };
    ;
    return CardWarningBanner;
}(plugin_journey_1.WidgetBase));
exports.CardWarningBanner = CardWarningBanner;
//# sourceMappingURL=CardWarningBanner.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/CardWarningBanner.js
// module id = 3163
// module chunks = 0